import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura"; 

import "./Formulario.css";
import { plantelDeMatricula } from "../utilities/plantel";
import { AvisoCatalogo } from "./FormularioExamen";

const MAXIMO_CONCEPTOS = 5;

const Formulario = ({
  conceptos,
  estadoCatalogo = "listo",
  alumno,
  precio,
  cambiarPrecio,
  datospago,
  cambiarDatosPago,
  claves,
  cambiarClaves,
  checked,
  cambiarChecked,
  cambiarPagar = () => {},
  pagar,
  cambiarTablaConceptos,
  tablaConceptos,
}) => {
  const history = useHistory();
  
  const [error, cambiarError] = useState(false);
  const [mensajeError, cambiarMensajeError] = useState("");
  // La seleccion ya no se borra al entrar: si el alumno regresa desde Forma de pago encuentra lo que habia
  // marcado. Se empieza de cero al elegir el tipo de pago (Tipo.js) y al salir (Header.js).
  const seleccionados = claves.length;

  // Por seguridad, si lo que hay guardado no es una seleccion de este formulario (por ejemplo, viene de
  // Examenes o de Egresados, que llenan la tabla y el precio pero no las claves), se empieza de cero.
  useEffect(() => {
    const clavesTabla = tablaConceptos.map((t) => t.clave);
    const sumaTabla = tablaConceptos.reduce((s, t) => s + Number(t.precio), 0);
    const esDeEsteFormulario =
      clavesTabla.length === claves.length &&
      clavesTabla.every((c) => claves.includes(c)) &&
      Number(precio) === sumaTabla;
    if (!esDeEsteFormulario) {
      cambiarPagar(false);
      cambiarPrecio(0);
      cambiarTablaConceptos([]);
      cambiarClaves([]);
      cambiarChecked({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (seleccionados > 0 && seleccionados < MAXIMO_CONCEPTOS) {
      cambiarError(false);
    }
  }, [seleccionados]);

  const removeItemFromArr = (arr, item) => {
    return arr.filter((e) => e !== item);
  };

  const removeItemFromObjArr = (arr, item) => {
    return arr.filter((e) => e.clave !== item);
  };

  const onCLickCheck = (concepto) => {
    if (concepto.checked) {
      // Desmarcar
      cambiarChecked({ ...checked, [concepto.id]: false });
      cambiarPrecio(precio - concepto.precio);
      cambiarClaves(removeItemFromArr(claves, concepto.clave));
      cambiarTablaConceptos(
        removeItemFromObjArr(tablaConceptos, concepto.clave)
      );
    } else {
      // Marcar (Verificando límite de 5)
      if (seleccionados >= MAXIMO_CONCEPTOS) {
        cambiarMensajeError(`Puedes pagar hasta ${MAXIMO_CONCEPTOS} conceptos a la vez. Quita uno para agregar otro.`);
        cambiarError(true);
        return;
      }
      
      cambiarChecked({ ...checked, [concepto.id]: true });
      cambiarPrecio(precio + concepto.precio);
      cambiarClaves([...claves, concepto.clave]);
      
      cambiarTablaConceptos([
        ...tablaConceptos,
        {
          concepto: concepto.concepto,
          clave: concepto.clave,
          precio: concepto.precio.toString(),
        },
      ]);
    }
  };

const HandleSubmit = async (e) => {
    e.preventDefault();

    if (claves.length === 0) {
      cambiarMensajeError("⚠️ Selecciona al menos un concepto para continuar.");
      cambiarError(true);
      return;
    }

    cambiarError(false);

    let importe = precio.toString().concat(".00");
    const matriculaStr = String(alumno.codigo);
    
    // Calculamos el plantel con las reglas exactas
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    // 1. Generamos TODAS las referencias (El Centro de Mando)
    const datosReferencia = generarLineaCaptura(plantelOficialAlumno, claves, matriculaStr, precio);
    
    // 2. Extraemos la de Banorte para mandarla a tu sistema viejo (Adquira)
    // SOLUCIÓN AL ERROR: Aquí agregamos el ".banorte"
    const lineaCapturaFinal = datosReferencia.banorte.lineaDeCaptura;


    // 3. Avanzamos a la siguiente pantalla con los datos actualizados
    // MEJORA: Mandamos todo el objeto "datosReferencia" para que el PDF tenga acceso a Bancomer
    cambiarDatosPago({
      referencia: lineaCapturaFinal,       // Línea Banorte (para retrocompatibilidad)
      referenciaBBVA: datosReferencia.bancomer.lineaDeCaptura, // Línea Bancomer
      importe: importe,
      detallesCompletos: datosReferencia   // Todo el paquete crudo por si lo necesitas
    });

    cambiarPagar(true);
    history.push("/formadepago");
  };

  const mitad = Math.ceil(conceptos.length / 2);
  const conceptosColumna1 = conceptos.slice(0, mitad);
  const conceptosColumna2 = conceptos.slice(mitad);

  // Toda la fila se puede tocar (antes solo la casilla de 14 px). La casilla detiene el clic para que no
  // se marque y desmarque dos veces; sigue siendo la que recibe el foco con el teclado.
  const filaConcepto = (concepto, index) => (
    <tr
      key={concepto.clave}
      className={`Formulario-fila${index % 2 !== 0 ? " Formulario-par" : ""}${concepto.checked ? " Formulario-fila--marcada" : ""}`}
      onClick={() => onCLickCheck(concepto)}
    >
      <td className="Formulario-concepto">{concepto.concepto}</td>
      <td className="td-center">${Number(concepto.precio).toFixed(2)}</td>
      <td className="td-center">
        <input
          type="checkbox"
          id={concepto.id}
          aria-label={concepto.concepto}
          checked={concepto.checked}
          onClick={(e) => e.stopPropagation()}
          onChange={() => onCLickCheck(concepto)}
        />
      </td>
    </tr>
  );

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="Formulario-container container">
      <button 
        className="Formulario-btn-regresar" 
        onClick={() => history.push("/tipo")}
      >
        &#8592; Regresar
      </button>

      <div className="Formulario-card">
        <h3>Conceptos Generales <span>Máximo 5 permitidos</span></h3>
        <p>Selecciona los conceptos que deseas pagar de la siguiente lista tocando el concepto o su casilla. El total se calculará automáticamente.</p>
      </div>

      {estadoCatalogo !== "listo" ? (
        <AvisoCatalogo estado={estadoCatalogo} />
      ) : conceptos.length === 0 ? (
        <div className="Formulario-error">
          <p>Por ahora no hay conceptos disponibles para pago en línea. Consulta en tu plantel.</p>
        </div>
      ) : (
      <form onSubmit={HandleSubmit}>
        <div className="Formulario-flex">
          <div className="Formulario-table-wrapper">
            <div className="Formulario-tables-grid">
              
              <table className="Formulario-table">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th className="th-center">Costo</th>
                    <th className="th-center">Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  {conceptosColumna1.map(filaConcepto)}
                </tbody>
              </table>

              <table className="Formulario-table Formulario-table-right">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th className="th-center">Costo</th>
                    <th className="th-center">Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  {conceptosColumna2.map(filaConcepto)}
                </tbody>
              </table>

            </div>
          </div>

          {/* En celular esta caja se queda fija abajo: el alumno ve el total y CONTINUAR mientras elige */}
          <div className="Formulario-paybox">
            <div className="Formulario-total">
              <h4>Total: <span>${Number(precio).toFixed(2)}</span></h4>
              <p className="Formulario-contador">
                {seleccionados === 0
                  ? "Ningún concepto seleccionado"
                  : `${seleccionados} de ${MAXIMO_CONCEPTOS} conceptos`}
              </p>
            </div>
            
            {error ? (
              <div className="Formulario-error">
                <p>{mensajeError}</p>
              </div>
            ) : null}
            
            <input 
              className="Formulario-boton" 
              type="submit" 
              value="CONTINUAR"
            />
          </div>
          
        </div>
      </form>
      )}
    </div>
  );
};

export default Formulario;